module.exports = __webpack_public_path__ + "static/media/acura-pin.1743223b.svg";